module.exports = __webpack_public_path__ + "static/img/ri-shopping-basket-line.46dd3c15.svg";